<template>
  <div>
    <!-- <app-history
      @clicked="openRequest(1)"
      title="درخواست کمک هزینه اجاره مسکن"
    />
    <app-history
      @clicked="openRequest(2)"
      title=" درخواست کمک هزینه خرید مسکن"
    /> -->
    <app-history @clicked="$router.push('/home-request-history')" />
    <v-card class="fullForm">
      <div class="fullText">
        <span
          >از این پس، امور ثبت قرارداد برای دریافت کمک هزینه اجاره مسکن و کمک
          هزینه خرید مسکن از طریق پایگاه اطلاع رسانی «امین» انجام می شود.</span
        >
        <br />
        <br />
        <span
          >متقاضیان دریافت کمک هزینه مسکن و ثبت قرارداد جدید می‌توانند از ۱۰
          مهرماه ۱۴۰۲ مستندات خود را در پایگاه اطلاع رسانی امین به نشانی

          <a href="https://amin11.ir" target="_blank">amin11.ir</a>
          بارگذاری کنند.</span
        >
      </div>
    </v-card>
    <!-- <div v-if="active.length > 0">
      <app-home-request
        v-for="index in active.length"
        :key="index"
        :index="index - 1"
        :homeRequest="active[index - 1]"
        :showedit="true"
        @edit="editHomeRequest"
        @cancel="cancelHomeRequest"
        @confirm="showConfirmDialog"
      >
      </app-home-request>
    </div>
    <div v-else-if="!progress" style="margin: 20px">
      {{ tableText }}
    </div> -->
    <app-dialog @close="closeDialog"></app-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import {
  cancelEjareRequest,
  confirmEjare,
  removeBuyRequest,
  confirmBuy,
} from "@/api/home-request";
import Dialog from "@/components/Dialog";
import Item from "./Item";
import HistoryButton from "@/components/HistoryButton";
export default {
  components: {
    appDialog: Dialog,
    appHomeRequest: Item,
    appHistory: HistoryButton,
  },
  methods: {
    /**
     * commit cancel or confirm homeRequest
     */
    closeDialog(index) {
      if (index != -1) {
        if (this.dialogType == 1) {
          if (this.requestType == 1) {
            cancelEjareRequest(index)
              .then((response) => {
                const data = response.data;
                if (data.Success) {
                  this.$store.dispatch("getActiveSessions");
                }
                this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
              })
              .catch((error) => {
                this.$store.commit(
                  "SET_SNACKBAR_TEXT",
                  "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
                );
              });
          } else if (this.requestType == 2) {
            removeBuyRequest(index)
              .then((response) => {
                const data = response.data;
                if (data.Success) {
                  this.$store.dispatch("getActiveSessions");
                }
                this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
              })
              .catch((error) => {
                this.$store.commit(
                  "SET_SNACKBAR_TEXT",
                  "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
                );
              });
          }
        } else if (this.dialogType == 2) {
          if (this.requestType == 1) {
            confirmEjare(index, this.confirm)
              .then((response) => {
                const data = response.data;
                if (data.Success) {
                  this.$store.dispatch("getActiveSessions");
                }
                this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
              })
              .catch((error) => {
                this.$store.commit(
                  "SET_SNACKBAR_TEXT",
                  "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
                );
              });
          } else if (this.requestType == 2) {
            confirmBuy(index, this.confirm)
              .then((response) => {
                const data = response.data;
                if (data.Success) {
                  this.$store.dispatch("getActiveSessions");
                }
                this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
              })
              .catch((error) => {
                this.$store.commit(
                  "SET_SNACKBAR_TEXT",
                  "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
                );
              });
          }
        }
      }
      this.$store.commit("SET_DIALOG_SHOW", false);
    },
    /**
     * check user has shahrie
     */
    openRequest(type) {
      if (type == 1) {
        this.$store.commit("SET_CURRENT_HOME_REQUEST", {});
        this.$router.push("/ejare-new");
      } else {
        this.$store.commit("SET_CURRENT_HOME_REQUEST", {});
        this.$router.push("/buy-new");
      }
    },

    /**
     * show current ejare
     */
    editHomeRequest(index) {
      this.$store.commit("SET_CURRENT_HOME_REQUEST", this.active[index]);
      this.$router.push("/ejare-new");
    },
    /**
     * show cancel ejare
     */
    cancelHomeRequest(serial, type) {
      this.dialogType = 1;
      this.requestType = type;
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", serial);
      this.$store.commit(
        "SET_DIALOG_MESSAGE",
        type == 1
          ? "آیا مایل به فسخ این قرارداد هستید؟"
          : "آیا مایل به لغو این قرارداد هستید؟"
      );
      this.$store.commit("SET_DIALOG_SHOW", true);
    },

    /**
     * show cancel ejare
     */
    showConfirmDialog(serial, type, state, name, address) {
      this.dialogType = 2;
      this.confirm = state;
      this.requestType = type;
      this.$store.commit("SET_DIALOG_ICON", "exclamation");
      this.$store.commit("SET_DIALOG_TYPE", 1);
      this.$store.commit("SET_DIALOG_KEY", serial);
      let message =
        state == 0
          ? "آیا مطمئن هستید که این درخواست را رد می‌کنید؟"
          : "آیا مطمئن هستید که این درخواست را تایید می‌کنید؟" +
            "<br/><br/>" +
            "گواهی: اینجانب شرعاً و قانوناً با آگاهی کامل تأیید سکونت " +
            name +
            " را در مسکن مسکونی به آدرس " +
            address +
            " گواهی می‌نمایم و به مرکز مدیریت حوزه علمیه خراسان وکالت می‌دهم در صورت مغایرت با واقعیت مبالغ پرداخت شده به نامبردگان را از شهریه اینجانب برداشت نمایند. ";

      this.$store.commit("SET_DIALOG_MESSAGE", message);
      this.$store.commit("SET_DIALOG_SHOW", true);
    },
  },
  created() {
    // this.$store.dispatch("getActiveSessions");
  },
  computed: {
    active() {
      return this.$store.getters.activeHomeRequest;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
    progress() {
      return this.$store.getters.progress;
    },
  },
  data() {
    return {
      dialogType: 0,
      confirm: -1,
      requestType: -1,
      name: "",
      address: "",
    };
  },
};
</script>
<style scoped>
.v-btn {
  margin-right: 30px;
  width: 200px;
}
</style>
